/* ASPIRE UI THEME **/
/* ASPIRE IQ THEME */

/* ASPIRE UI THEME **/
/* ASPIRE IQ THEME */

/* ASPIRE UI THEME **/
/* ASPIRE IQ THEME */

/* ASPIRE UI THEME **/
/* ASPIRE IQ THEME */

._flex_17dfp_157 {
  display: flex;
}

._justify-content-space-between_17dfp_161 {
  justify-content: space-between;
}

._tabular-nums_17dfp_165 {
  font-variant-numeric: tabular-nums;
}

@keyframes _show_17dfp_1 {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
/* Text styles */
._SocialProfileCell_17dfp_178 {
  width: 100%;
}
._SocialProfileCell_17dfp_178 ._username_17dfp_181 {
  cursor: pointer;
  transition: color 0.15s cubic-bezier(0.23, 1, 0.32, 1);
}
._SocialProfileCell_17dfp_178 ._username_17dfp_181:hover {
  color: #3996e0;
}

._profileLinkOnErrorToast_17dfp_189,
._profileLinkOnErrorToast_17dfp_189:hover,
._profileLinkOnErrorToast_17dfp_189:active {
  color: #fdfdfd;
  text-decoration: underline;
}